import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconSourceSvg } from "./IconSourceSvg.mjs";
const IconSource = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconSourceSvg, ...iconProps });
};
export {
  IconSource
};
